import Header from '../components/global/header'
import TermsHero from '../components/terms/terms-hero'

export default function About() {
    return (
      <>
      <Header />
      <TermsHero />
    
      </>
    );
  }